const validateEmail = (val: string): boolean => {
  return /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(val)
}

export type formItem = {
  type?: string
  name?: string
  length?: number
  value?: string
  placeholder?: string
  clearable?: boolean
  isClearValue?: boolean
  eyes?: boolean
  iconClass?: string
  hasError?: boolean
  error?: any // api提示
  emptyError?: string // 空值提示
  valueError?: string // 有值提示
  rule?: any
  validate?: any
  customError?: boolean // 自定义错误信息展示，比如密码校验
}

export const createFormItemData = (props?: formItem): formItem => {
  return Object.assign(
    {
      type: 'text',
      name: '',
      value: '',
      clearable: true,
      eyes: false,
      iconClass: '',
      placeholder: '',
      hasError: false,
      error: '',
      emptyError: '',
      valueError: '',
      validate() {
        let pass = true
        if (this.rule) {
          if (this.rule instanceof RegExp) {
            pass = this.rule.test(this.value)
          } else if (typeof this.rule === 'function') {
            pass = this.rule(this.value)
          }
          this.hasError = !pass
        }
        return pass
      }
    } as formItem,
    props
  )
}

export const createEmailItemData = (props?: formItem): formItem => {
  return createFormItemData(
    Object.assign(
      {
        type: 'text',
        name: 'email',
        placeholder: 'Email Address',
        rule: (value: formItem['value']) => {
          if (value && validateEmail(value.toString())) {
            return true
          } else {
            return false
          }
        },
        emptyError: 'Please enter an email address.',
        valueError: 'Please enter a valid email address.'
      },
      props
    )
  )
}

export const createPasswordItemData = (props?: formItem): formItem => {
  return createFormItemData(
    Object.assign(
      {
        type: 'password',
        name: 'password',
        eyes: true,
        placeholder: 'Password',
        rule: (value: formItem['value']) => {
          if (value && /^.{6,20}$/.test(value.toString())) {
            return true
          } else {
            return false
          }
        },
        emptyError: 'Please enter your password.',
        valueError: 'Password is incorrect. Please try again.'
      },
      props
    )
  )
}

export const createFullnameItemData = (props?: formItem): formItem => {
  return createFormItemData(
    Object.assign(
      {
        type: 'text',
        name: 'full_name',
        rule: (value: formItem['value']) => {
          if (value && /^.{1,25}$/.test(value.toString())) {
            return true
          } else {
            return false
          }
        },
        emptyError: 'Please enter your full name.',
        valueError: 'Please enter your full name.'
      },
      props
    )
  )
}

export const passwordAllowSymbolArr = [
  '~',
  '`',
  '!',
  '@',
  '#',
  '$',
  '%',
  '^',
  '&',
  '*',
  '(',
  ')',
  '_',
  '-',
  '+',
  '=',
  '{',
  '}',
  '[',
  ']',
  '|',
  ';',
  ':',
  ',',
  '<',
  '>',
  '.',
  '?',
  '/'
]
// 是否有包含以下字符
export const passwordContainReg = new RegExp(
  `[0-9a-zA-Z${passwordAllowSymbolArr.join('\\')}]+`
)
// 是否只包含以下字符
export const passwordRegexp = new RegExp(
  `^[0-9a-zA-Z${passwordAllowSymbolArr.join('\\')}]*$`
)
// 非规定字符错误提示
export const passwordSymbolTip = `Symbol not allowed. Please use these instead ${passwordAllowSymbolArr.join(
  ' '
)}`
